var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useQuery } from '@tanstack/react-query';
import { useAuthProvider, useLucidSdk } from '#context';
import { WorkspaceLoginStatusKeyFactory } from '../../query-key-factories';
export const workspaceLoginStatusQueryFactory = ({ lucidSdk, workspaceId, }) => ({
    queryKey: WorkspaceLoginStatusKeyFactory.byWorkspace(workspaceId),
    queryFn: () => lucidSdk.workspaceClient(workspaceId).getLoginStatus(),
});
export const useGetWorkspaceLoginStatus = (workspaceId) => {
    _react_refresh_temp_1();
    const { lucidSdk } = useLucidSdk();
    const { currentUser } = useAuthProvider();
    const query = useQuery({
        ...workspaceLoginStatusQueryFactory({ workspaceId, lucidSdk }),
        networkMode: 'always',
        enabled: Boolean(currentUser?.emailVerified && workspaceId !== ''),
        retry: false,
    });
    return { query };
};
_react_refresh_temp_1(useGetWorkspaceLoginStatus, "wEg9DMWQ/CI4rGOcHGIhupr8WvQ=", false, () => [useLucidSdk, useAuthProvider, useQuery]);
